import { NavLink } from "./NavLink";
import { T } from "../../util/t";
import { RunEventMenu } from "../menus/RunEventMenu";
import { Box, Link } from "@mui/material";
import { CurrentUser } from "components/providers/CurrentUserProvider";
import { Sx } from "utils/sx";

const mobileStyles: Sx = (theme) => ({
    marginTop: theme.spacing(2),
});

const styles: Sx = (theme) => ({
    display: "flex",
    gap: theme.spacing(4),
    whiteSpace: "nowrap",
    paddingLeft: theme.spacing(1),
    "& > a": {
        display: "inline-flex",
        whiteSpace: "nowrap",
    },
});

export const NavMenuLinks = ({
    user,
    anchorEl,
    openMenu,
    closeMenu,
    clickLink,
    isMobile,
}: {
    user?: CurrentUser;
    anchorEl: HTMLElement | null;
    openMenu: (event: React.MouseEvent<HTMLAnchorElement>) => void;
    closeMenu: () => void;
    clickLink?: () => void;
    isMobile: boolean;
}) => {
    return (
        <Box sx={isMobile ? mobileStyles : styles}>
            {!user && (
                <>
                    <RunEventMenu
                        isMobile={isMobile}
                        anchorEl={anchorEl}
                        openMenu={openMenu}
                        closeMenu={closeMenu}
                    />
                    <Link href="/sign-up" variant="subtitle2" underline="none">
                        <T>Sign up</T>
                    </Link>
                </>
            )}

            {user?.role === "judge" && (
                <NavLink to="/dashboard/judge" onClick={clickLink}>
                    <T>Events</T>
                </NavLink>
            )}

            {user?.role === "director" && (
                <>
                    <NavLink to="/director" onClick={clickLink}>
                        <T>Events</T>
                    </NavLink>
                    <NavLink
                        to="/director/rankings-and-memberships"
                        onClick={clickLink}
                    >
                        <T>Rankings & memberships</T>
                    </NavLink>
                    <NavLink to="/director/athletes-teams" onClick={clickLink}>
                        <T>Athletes & teams</T>
                    </NavLink>

                    {user.organisation?.stripe_account_type === "express" && (
                        <NavLink to="/director/payments" onClick={clickLink}>
                            <T>Payments (legacy)</T>
                        </NavLink>
                    )}
                </>
            )}
        </Box>
    );
};
